// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js!./quill.bubble.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../vue-style-loader/lib/addStylesClient.js")("9194327e", content, true);


//////////////////
// WEBPACK FOOTER
// ./~/quill/dist/quill.bubble.css
// module id = 35
// module chunks = 0